'use client';

import React, { useCallback } from 'react';
import { useEffect } from 'react';
import { Button, ButtonProps } from '@keyslabor/shared/ui';

interface ButtonFillEffectProps extends ButtonProps {
  children?: React.ReactNode;
  progress?: number;
  isPlaying?: boolean;
}

export default function ButtonFillEffect({
  children,
  progress = 0,
  isPlaying,
  ...props
}: ButtonFillEffectProps) {
  const buttonRef = React.useRef<HTMLButtonElement | null>(null);
  const [curWidth, setCurWidth] = React.useState(0);
  const curAnimationId = React.useRef<number | null>(null);

  const handleClearAnimation = useCallback(() => {
    if (curAnimationId.current) {
      cancelAnimationFrame(curAnimationId.current);
      curAnimationId.current = null;
    }
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      setCurWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (!isPlaying) {
      handleClearAnimation();
      return;
    }
  });

  return (
    <Button
      ref={buttonRef}
      overflow="hidden"
      position="relative"
      maxWidth="332px"
      width="100%"
      kind="large"
      {...props}
    >
      <div
        style={{
          position: 'relative',
          zIndex: 2,
        }}
      >
        {children}
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: Math.min(progress * curWidth, curWidth) + 'px',
          width: '100%',
          height: '100%',
          backgroundColor: 'lightblue',
          transition: 'left 0.5s',
          opacity: 0.5,
          zIndex: 1,
        }}
      ></div>
    </Button>
  );
}
